import type { Editor, EditorEvents } from '@tiptap/core';
import { Observable } from 'rxjs';

// Tiptap's EventEmitter wraps non-array payloads in a conditional tuple type
// that TypeScript cannot resolve when the event name is a generic K.
// All EditorEvents values are objects (never arrays), so this simplified
// signature is safe at runtime.
type EditorEventFn = <K extends keyof EditorEvents>(event: K, fn: (data: EditorEvents[K]) => void) => Editor;

export function fromEditorEvent<K extends keyof EditorEvents>(editor: Editor, event: K): Observable<EditorEvents[K]> {
  return new Observable<EditorEvents[K]>((subscriber) => {
    const handler = (data: EditorEvents[K]): void => subscriber.next(data);
    (editor.on as EditorEventFn)(event, handler);
    return () => {
      (editor.off as EditorEventFn)(event, handler);
    };
  });
}
